import * as React from 'react'

import "./style.scss"

import {AppContext} from "../../../Context/AppContext"

import {postier} from "./Postier"
import { Download } from '../../Utils/Download'
import { Create } from './create'
import { ReactElement, useContext, useEffect, useState } from 'react'

export function Events(): ReactElement {

    const {token,site,client,setLoading, setErrors, role} = useContext(AppContext)
    const [event, setEventData] = useState([])
    const [pagina, setPagina] = useState('main');
    const [eventsTypes, setEventsTypes] = useState([]);


    const setEvents = (arg)=>{
        setLoading(false)
        setEventData(arg)
    }

    useEffect(() => {
        setLoading(true)
        site?postier.getEvents(token,client,site,setEvents, setErrors):null;
    }, [site])

    useEffect(() => {
        postier.getEventsTypes(token, client.split(':')[3], setEventsTypes, setErrors)
    }, [])

    const camera = event.map(cam=>{
    
    const fromDate = new Date(cam.FromDate)
    const toDate = new Date(cam.ToDate)


    
    return <tr key={cam.ID} className="line" >
            <td>{cam.ID}</td>
            <td>{cam.Title}</td>
            <td>{cam.Label}</td>
            <td>{cam.Name}</td>
            <td>{cam.Description}</td> {/** On utilise event reported */}
            <td>{fromDate.toLocaleDateString()}</td>
            <td>{toDate.toLocaleDateString()}</td>
        </tr>
        })

    return (

        <div className="event">

            <h1>Liste des évènements</h1>
            {pagina === 'main' ? role !== 'Viewer' && pagina === 'main' && <button onClick={() => setPagina('createEvent')}>Créer un évènement</button> : <button onClick={() => setPagina('main')}>Retour au menu</button>}
            {pagina === 'createEvent' && <Create setPagina={setPagina} eventsTypes={eventsTypes} />}
            {pagina === 'main' && 
            <table id="table">
                        <thead>
                            <tr className="line" >
                                <td>id</td>
                                <td>titre</td>
                                <td>type</td>
                                <td>évènement</td>
                                <td>description</td>
                                <td>début</td>
                                <td>fin</td>


                            </tr>
                        </thead>
                        <tbody>
                            {camera}
                        </tbody>
                    </table>
            }
                    {pagina !== 'createEvent' && <Download id="table" clientCode={client.split(":")[0]} siteId={site.split(":")[0]} type={"events"} />}
        </div>

        
    )
}
